"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KindOfPlace = void 0;
var KindOfPlace;
(function (KindOfPlace) {
    KindOfPlace[KindOfPlace["EntirePlace"] = 0] = "EntirePlace";
    KindOfPlace[KindOfPlace["PrivateRoom"] = 1] = "PrivateRoom";
    KindOfPlace[KindOfPlace["SharedRoom"] = 2] = "SharedRoom";
})(KindOfPlace = exports.KindOfPlace || (exports.KindOfPlace = {}));
//# sourceMappingURL=KindOfPlaceEnum.js.map